// // src/components/ApartmentsOverviewWithImages.jsx
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FaMosque, FaEye, FaHome } from "react-icons/fa";
// import { useLocation } from "react-router-dom";

// export const categories = [
//   {
//     id: 1,
//     name: "Studio Apartment",
//     icon: <FaHome />,
//     view: "City View",
//     price: "$90 – $100 / Night",
//     description:
//       "Modern studio apartment with Islamabad skyline view and fully furnished luxury interior.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637351/Studio_Apartment_3_m3z241.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637350/Studio_Apartment_1_hsslfl.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637350/Studio_Apartment_2_pbbmgz.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637351/Studio_Apartment_4_ts0ax3.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773299768/PHOTO-2026-03-03-09-37-04_uksf2k.jpg",
//     ],
//   },
//   {
//     id: 2,
//     name: "1 Bed Apartment Faisal Mosque",
//     icon: <FaMosque />,
//     view: "Mosque View",
//     price: "$100 – $120 / Night",
//     description:
//       "Spacious 1 bedroom apartment with direct Faisal Mosque view and elegant design.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/1_bed_faisal_mosque_k6yimp.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700889/One_Bed_Apartment_Faisal_Mosque6_mob0fm.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700889/One_Bed_Apartment_Faisal_Mosque5_z6qsbr.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700280/One_Bed_Apartment_Faisal_Mosque2_bxgmry.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700280/One_Bed_Apartment_Faisal_Mosque4_kqesmw.jpg",
//     ],
//   },
//   {
//     id: 3,
//     name: "2 Bed Study Apartment",
//     icon: <FaEye />,
//     view: "Study Room",
//     price: "$160 – $190 / Night",
//     description:
//       "Luxury 2 bedroom apartment with study area and premium modern furniture.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/2_bed_Study_Apartmant_cahvu3.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702947/2_Bed_Study_Apartment4_ciihj6.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702947/2_Bed_Study_Apartment1_tkygcf.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702948/2_Bed_Study_Apartment3_taqqdw.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702948/2_Bed_Study_Apartment2_gevqwd.jpg",
//     ],
//   },
//   {
//     id: 4,
//     name: "2 Bed Apartment Faisal Mosque",
//     icon: <FaMosque />,
//     view: "Mosque View",
//     price: "$135 – $160 / Night",
//     description:
//       "Premium 2 bedroom apartment with panoramic Faisal Mosque and Margalla Hills view.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/2_bed_faisal_mosque_view_vr3x6n.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-09-16_zaszcj.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-07-54_fn7ygl.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-19-59-41_gyletw.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-01-39_rnzpbf.jpg",
//     ],
//   },
//   {
//     id: 5,
//     name: "3 Bed Apartment Faisal Mosque",
//     icon: <FaMosque />,
//     view: "Mosque View",
//     price: "$195 – $225 / Night",
//     description:
//       "Ultra luxury 3 bedroom apartment with breathtaking Faisal Mosque and Margalla Hills view, perfect for families and groups.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment2_nmkb4h.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment1_ef8kzm.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment5_xkadft.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment6_brzilx.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment7_xsci0c.jpg",
//     ],
//   },
//   {
//     id: 6,
//     name: "1 Bed Study Apartment Cross View",
//     icon: <FaEye />,
//     view: "Cross View",
//     price: "$105 – $135 / Night",
//     description:
//       "Elegant 1 bedroom apartment with dedicated study space and beautiful cross view of Islamabad city.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView3_moojnb.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView_wga8yu.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView5_hqn2ox.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182422/1BedStudyApartmentCrossView2_xtopce.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182687/1BedStudyApartmentCrossView4_v8mhty.jpg",
//     ],
//   },
//   {
//     id: 7,
//     name: "2 Bed Study Apartment Cross View",
//     icon: <FaEye />,
//     view: "Cross View",
//     price: "$160 – $190 / Night",
//     description:
//       "Luxury 2 bedroom apartment with study room and panoramic cross view of Islamabad skyline.",
//     images: [
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView1_upveg4.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179665/2BedStudyApartmentCrossView5_ynsbko.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView3_jinp17.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView2_xqfhnt.jpg",
//       "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179665/2BedStudyApartmentCrossView4_bvrusk.jpg",
//     ],
//   },
// ];
// const ApartmentShowcase = () => {
//   const location = useLocation();
//   const isApartmentsPage = location.pathname === "/apartments";

//   const [activeCategory, setActiveCategory] = useState(categories[0]);
//   const [activeImage, setActiveImage] = useState(categories[0].images[0]);
// const displayedCategories = isApartmentsPage
//   ? categories
//   : categories.slice(0, 4);
//   return (
//     <>
//       {/* APARTMENT SECTION */}
//       <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0" id="apartment">
//         <div className="container-custom">
//           {/* TOP GRID */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8  md:gap-16" id="currentapartment">
//             {/* LEFT BIG IMAGE */}
//             <div className="relative">
//               <div className="absolute -top-6 -left-6 w-full h-full bg-[#c9a86c] opacity-20"></div>

//               <img
//                 src={activeImage}
//                 alt="Apartment"
//                 className="relative z-10 w-full h-[500px] object-cover rounded-lg shadow-xl transition-all duration-500"
//               />
//             </div>

//             {/* RIGHT CONTENT */}
//             <div className="space-y-4">
//               <div className="flex items-center gap-3">
//                 <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//                 <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//                   Apartment
//                 </span>
//                 <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//               </div>
//               <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
//                 {activeCategory.name}
//               </h2>

//               <p className="text-[#c9a86c] text-2xl font-semibold">
//                 {activeCategory.price}
//               </p>

//               <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//                 {activeCategory.description}
//               </p>

//               {/* THUMBNAILS */}
//               <div className="grid grid-cols-2 md:grid-cols-5 gap-4 !mt-4">
//                 {activeCategory.images.map((img, index) => (
//                   <a href="#currentapartment">
//                   <img
//                     key={index}
//                     src={img}
//                     alt="thumb"
//                     onClick={() => setActiveImage(img)}
//                     className={`h-28 w-full object-cover rounded cursor-pointer transition ${
//                       activeImage === img
//                         ? "ring-2 ring-[#c9a86c]"
//                         : "opacity-80 hover:opacity-100"
//                     }`}
//                   />
//                   </a>
//                 ))}
//               </div>

//               <div className="flex md:flex-row flex-col space-x-3 pt-3 space-y-3 md:space-y-0">
//                 {" "}
//                 <Link
//     to={`/apartment/${activeCategory.id}`}
//     className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//   >
//     View More Detail
//   </Link>
//                 {/* <Link
//                   to="/contact"
//                   className="bg-transparent text-black border border-black px-8 py-4 rounded-full font-medium hover:bg-[#c9a86c] hover:text-white hover:border-none transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//                 >
//                   Apartment Demo
//                 </Link> */}
//               </div>
//             </div>
//           </div>

//           {/* BOTTOM CATEGORY CARDS */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-10 z-10 relative">
//            {displayedCategories.map((item) => (
//               <a
//               href={"#currentapartment"}
//                 key={item.id}
//                 onClick={() => {
//                   setActiveCategory(item);
//                   setActiveImage(item.images[0]);
//                 }}
//                 className={`relative group overflow-hidden rounded-lg shadow-lg cursor-pointer transition-all duration-300 ${
//                   activeCategory.id === item.id ? "ring-2 ring-[#c9a86c]" : ""
//                 }`}
//               >
//                 <img
//                   src={item.images[0]}
//                   alt={item.name}
//                   className="w-full h-64 object-cover group-hover:scale-110 transition duration-700"
//                 />

//                 <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition"></div>

//                 <div className="absolute bottom-6 left-6 text-white pr-2">
//                   <h3 className="text-lg font-medium">{item.name}</h3>
//                   <span className="text-sm opacity-80">{item.view}</span>
//                 </div>
//               </a>
//             ))}
//           </div>
//         </div>
//         {!isApartmentsPage && (
//           <div className="md:max-w-4xl md:mx-auto pt-6 md:pt-12 space-y-4 text-center container-custom">
//             <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
//               Discover More Luxury {" "}
//               <span className="font-bold text-[#c9a86c]">Living Options</span>
//             </h2>

//             <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
//               Explore our premium collection of serviced apartments in
//               Islamabad. Experience comfort, elegance and breathtaking views at
//               StayIN.
//             </p>

//             <div className="flex flex-col sm:flex-row justify-center gap-6">
//               <Link
//                 to="/apartments"
//                 className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
//               >
//                 View More Apartments
//               </Link>

//               {/* <Link
//               to="/contact"
//               className="border-2 border-white px-8 py-4 font-medium hover:bg-white hover:text-[#1a2b3c] transition"
//             >
//               Book Now
//             </Link> */}
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default ApartmentShowcase;



// src/components/ApartmentsOverviewWithImages.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaMosque, FaEye, FaHome } from "react-icons/fa";
import { useLocation } from "react-router-dom";

export const categories = [
  {
    id: 1,
    name: "Studio Apartment",
    icon: <FaHome />,
    view: "City View",
    price: "$90 – $100 / Night",
    description:
      "Explore Studio flats for rent at the centaurus islamabad, where luxury meets convenience in the vibrant blue area district. Experience modern living in our stylish Studio Apartments at Centaurus Islamabad. Holiday homes centaurus studio apartments offer a perfect blend of comfort and accessibility in the heart of the capital city",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637351/Studio_Apartment_3_m3z241.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637350/Studio_Apartment_1_hsslfl.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637350/Studio_Apartment_2_pbbmgz.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772637351/Studio_Apartment_4_ts0ax3.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773299768/PHOTO-2026-03-03-09-37-04_uksf2k.jpg",
    ],
  },
  {
    id: 2,
    name: "1 Bed Apartment Faisal Mosque",
    icon: <FaMosque />,
    view: "Mosque View",
    price: "$100 – $120 / Night",
    description:
      "Whether you prefer a cozy space or need more room to spread out , our 1-bed and 2-bed apartments faisal mosque view for rent at centaurus islamabad offer modern amenities and a prime location in the heart of the city. Experience luxury living with stylish accommodations designed for comfort and convenience. ",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/1_bed_faisal_mosque_k6yimp.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700889/One_Bed_Apartment_Faisal_Mosque6_mob0fm.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700889/One_Bed_Apartment_Faisal_Mosque5_z6qsbr.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700280/One_Bed_Apartment_Faisal_Mosque2_bxgmry.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772700280/One_Bed_Apartment_Faisal_Mosque4_kqesmw.jpg",
    ],
  },
  {
    id: 3,
    name: "2 Bed Study Apartment",
    icon: <FaEye />,
    view: "Study Room",
    price: "$160 – $190 / Night",
    description:
      "Whether you need extra space for work or relaxation, our 2-bed study apartments for rent at Centaurus Islamabad offer the perfect blend of comfort and functionality. Featuring modern amenities, stylish interiors, and a prime location in the heart of the city, these apartments provide a luxurious living experience tailored to your lifestyle. ",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521246/2_bed_Study_Apartmant_cahvu3.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702947/2_Bed_Study_Apartment4_ciihj6.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702947/2_Bed_Study_Apartment1_tkygcf.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702948/2_Bed_Study_Apartment3_taqqdw.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772702948/2_Bed_Study_Apartment2_gevqwd.jpg",
    ],
  },
  {
    id: 4,
    name: "2 Bed Apartment Faisal Mosque",
    icon: <FaMosque />,
    view: "Mosque View",
    price: "$135 – $160 / Night",
    description:
      "Enjoy breathtaking views of Faisal Mosque from our spacious 2-bed apartments for rent at Centaurus Islamabad. Designed with modern amenities and elegant interiors, these apartments offer the perfect combination of luxury, comfort, and convenience in one of the city’s most prestigious locations.",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772521245/2_bed_faisal_mosque_view_vr3x6n.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-09-16_zaszcj.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-07-54_fn7ygl.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-19-59-41_gyletw.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772652976/PHOTO-2026-03-04-20-01-39_rnzpbf.jpg",
    ],
  },
  {
    id: 5,
    name: "3 Bed Apartment Faisal Mosque",
    icon: <FaMosque />,
    view: "Mosque View",
    price: "$195 – $225 / Night",
    description:
      "Experience premium living in our 3-bed apartments with stunning Faisal Mosque views at Centaurus Islamabad. With spacious layouts, modern amenities, and stylish accommodations, these apartments are designed for families and individuals seeking comfort, elegance, and a prime city lifestyle.",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment2_nmkb4h.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment1_ef8kzm.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment5_xkadft.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment6_brzilx.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773175431/3BedApartment7_xsci0c.jpg",
    ],
  },
  {
    id: 6,
    name: "1 Bed Study Apartment Cross View",
    icon: <FaEye />,
    view: "Cross View",
    price: "$105 – $135 / Night",
    description:
      "Discover comfortable and stylish living in our 1-bed study apartments with cross views at Centaurus Islamabad. Featuring modern amenities, functional spaces, and elegant interiors, these apartments are ideal for professionals and individuals seeking convenience in the heart of the city.",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView3_moojnb.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView_wga8yu.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182423/1BedStudyApartmentCrossView5_hqn2ox.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182422/1BedStudyApartmentCrossView2_xtopce.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773182687/1BedStudyApartmentCrossView4_v8mhty.jpg",
    ],
  },
  {
    id: 7,
    name: "2 Bed Study Apartment Cross View",
    icon: <FaEye />,
    view: "Cross View",
    price: "$160 – $190 / Night",
    description:
      "Upgrade your lifestyle with our spacious 2-bed study apartments featuring beautiful cross views at Centaurus Islamabad. Offering modern amenities, sophisticated interiors, and a prime central location, these apartments are designed to deliver comfort, luxury, and everyday convenience.",
    images: [
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView1_upveg4.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179665/2BedStudyApartmentCrossView5_ynsbko.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView3_jinp17.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179666/2BedStudyApartmentCrossView2_xqfhnt.jpg",
      "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773179665/2BedStudyApartmentCrossView4_bvrusk.jpg",
    ],
  },
];

const ApartmentShowcase = () => {
  const location = useLocation();
  const isApartmentsPage = location.pathname === "/apartments";

  const [activeCategory, setActiveCategory] = useState(categories[0]);
  const [activeImage, setActiveImage] = useState(categories[0].images[0]);
  
  const displayedCategories = isApartmentsPage
    ? categories
    : categories.slice(0, 4);
    
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Luxury Serviced Apartments in Centaurus Islamabad | StayIN Apartments</title>
        <meta name="description" content="Explore premium serviced apartments in Centaurus Islamabad. Studio, 1-3 bedroom luxury suites with stunning Faisal Mosque views. Book your stay at StayIN today." />
        <meta name="keywords" content="serviced apartments Islamabad, Centaurus apartments, luxury apartments Islamabad, Faisal Mosque view apartments, StayIN apartments" />
      </Helmet>

      {/* APARTMENT SECTION */}
      <section className="py-12 bg-gradient-to-b from-[#f1f1f1] via-[#f1f1f1]/0 to-[#f1f1f1]/0" id="apartment">
        <div className="container-custom">
          {/* TOP GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16" id="currentapartment">
            {/* LEFT BIG IMAGE */}
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-full h-full bg-[#c9a86c] opacity-20"></div>

              <img
                src={activeImage}
                alt={`${activeCategory.name} - Luxury serviced apartment in Centaurus Islamabad`}
                className="relative z-10 w-full h-[500px] object-cover rounded-lg shadow-xl transition-all duration-500"
              />
            </div>

            {/* RIGHT CONTENT */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
                <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                  Apartment
                </span>
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              </div>
              <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
                {activeCategory.name}
              </h2>

              {/* <p className="text-[#c9a86c] text-2xl font-semibold">
                {activeCategory.price}
              </p> */}

              <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
                {activeCategory.description}
              </p>

              {/* THUMBNAILS */}
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 !mt-4">
                {activeCategory.images.map((img, index) => (
                  <a href="#currentapartment" key={index}>
                    <img
                      src={img}
                      alt={`${activeCategory.name} view ${index + 1}`}
                      onClick={() => setActiveImage(img)}
                      className={`h-28 w-full object-cover rounded cursor-pointer transition ${
                        activeImage === img
                          ? "ring-2 ring-[#c9a86c]"
                          : "opacity-80 hover:opacity-100"
                      }`}
                    />
                  </a>
                ))}
              </div>

              <div className="flex md:flex-row flex-col space-x-3 pt-3 space-y-3 md:space-y-0">
                <Link
                  to={`/apartment/${activeCategory.id}`}
                  className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
                  aria-label={`View details for ${activeCategory.name}`}
                >
                  View More Detail
                </Link>
              </div>
            </div>
          </div>

          {/* BOTTOM CATEGORY CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-10 z-10 relative">
            {displayedCategories.map((item) => (
              <a
                href={"#currentapartment"}
                key={item.id}
                onClick={() => {
                  setActiveCategory(item);
                  setActiveImage(item.images[0]);
                }}
                className={`relative group overflow-hidden rounded-lg shadow-lg cursor-pointer transition-all duration-300 ${
                  activeCategory.id === item.id ? "ring-2 ring-[#c9a86c]" : ""
                }`}
                aria-label={`View ${item.name} - ${item.view}`}
              >
                <img
                  src={item.images[0]}
                  alt={`${item.name} - ${item.view} serviced apartment in Centaurus Islamabad`}
                  className="w-full h-64 object-cover group-hover:scale-110 transition duration-700"
                />

                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition"></div>

                <div className="absolute bottom-6 left-6 text-white pr-2">
                  <h3 className="text-lg font-medium">{item.name}</h3>
                  <span className="text-sm opacity-80">{item.view}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
        
        {!isApartmentsPage && (
          <div className="md:max-w-4xl md:mx-auto pt-6 md:pt-12 space-y-4 text-center container-custom">
            <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight">
              Discover More Luxury{" "}
              <span className="font-bold text-[#c9a86c]">Living Options</span>
            </h2>

            <p className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed">
              Explore our premium collection of serviced apartments in
              Islamabad. Experience comfort, elegance and breathtaking views at
              StayIN.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-6">
              <Link
                to="/apartments"
                className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
                aria-label="View all luxury apartments in Centaurus Islamabad"
              >
                View More Apartments
              </Link>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default ApartmentShowcase;